import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import toast from "react-hot-toast"

import { Modal } from "../../../components/Modal"
import { Button } from "../../../components/Button"
import { AutoComplete } from "../../../components/AutoComplete"
import autoCompleteStyles from "../../../components/AutoComplete/autoCompleteStyles"
import { CreateTrailerEquipment } from "../../../api/api.service"

const ManageImportGlobalEquipmentModal = ({
   isOpen = false,
   onToggleModal = () => {},
   equipmentsOptions = {},
   setEquipmentsOptions = () => {},
   handleSearchEquipment = () => {},
   selectedEquipments = [],
   setSelectedEquipments = () => {},
   trailerId = "",
   onSuccess = () => {},
   existingTrailerEquipments = [],
}) => {
   const [isLoading, setIsLoading] = useState(false)
   const [existingEquipmentIds, setExistingEquipmentIds] = useState([])

   useEffect(() => {
      const ids = existingTrailerEquipments.map(
         equipment => equipment.configuratorEquipmentSubTypeId
      )
      setExistingEquipmentIds(ids)
   }, [existingTrailerEquipments])

   const handleSelectEquipments = selectedOptions => {
      setSelectedEquipments(selectedOptions || [])
   }

   const handleRemoveChip = equipmentToRemove => {
      const updatedEquipments = selectedEquipments.filter(
         equipment => equipment.value !== equipmentToRemove.value
      )
      setSelectedEquipments(updatedEquipments)
   }

   const handleSubmit = async () => {
      if (!selectedEquipments || selectedEquipments.length === 0) {
         toast.error("Please select at least one equipment")
         return
      }

      try {
         setIsLoading(true)
         const equipmentIds = selectedEquipments.map(
            equipment => equipment.value
         )

         const payload = {
            trailerId: Number(trailerId),
            globalEquipmentIds: equipmentIds,
         }

         await CreateTrailerEquipment(payload)
         toast.success(
            `${selectedEquipments.length} equipment(s) added successfully!`
         )
         onToggleModal()
         setSelectedEquipments([])
         onSuccess()
      } catch (error) {
         toast.error("Failed to add equipment")
      } finally {
         setIsLoading(false)
      }
   }

   const handleModalClose = () => {
      setSelectedEquipments([])
      setEquipmentsOptions(prev => {
         return {
            ...prev,
            page: 1,
            Q: "",
         }
      })
      onToggleModal()
   }

   return (
      <Modal
         isOpen={isOpen}
         handleModalToggling={handleModalClose}
         bodyClassName=""
         customButton={true}
         hideModalHeaderSeparator={true}
         headerClasses="header-container mb-0"
         size="md"
         backdrop="static"
         modalTitle="Select Equipment Categories"
         scrollable
      >
         <div style={{ pointerEvents: isLoading ? "none" : "auto" }}>
            <Row>
               <Col xs={12}>
                  <div className="mb-3">
                     <AutoComplete
                        isMulti
                        handleBlur={() =>
                           setEquipmentsOptions(prev => {
                              return {
                                 ...prev,
                                 page: 1,
                                 Q: "",
                              }
                           })
                        }
                        onChange={handleSelectEquipments}
                        onInputChange={handleSearchEquipment}
                        placeholder="Select equipment categories"
                        classNamePrefix="status-header-search-admin"
                        customStyles={autoCompleteStyles.STYLE_TEN}
                        options={equipmentsOptions?.data}
                        isClearable={true}
                        value={selectedEquipments}
                        isLoading={equipmentsOptions?.fetching}
                        closeMenuOnSelect={false}
                        menuPortalTarget={document.body}
                        isOptionDisabled={option =>
                           existingEquipmentIds.includes(option.value)
                        }
                     />
                  </div>

                  <div className="mb-3">
                     <div className="Global-selected-features-container">
                        {selectedEquipments && selectedEquipments.length > 0 ? (
                           <div className="d-flex flex-wrap gap-2">
                              {selectedEquipments.map((equipment, index) => (
                                 <span
                                    key={`${equipment.value}-${index}`}
                                    className="Global-feature-chip"
                                 >
                                    <span>{equipment.label}</span>
                                    <button
                                       type="button"
                                       onClick={() =>
                                          handleRemoveChip(equipment)
                                       }
                                       aria-label="Remove"
                                       className="Global-feature-chip-remove-btn"
                                    >
                                       ×
                                    </button>
                                 </span>
                              ))}
                           </div>
                        ) : (
                           <div className="no-features-selected">
                              No equipment categories selected
                           </div>
                        )}
                     </div>
                  </div>

                  <div className="d-flex justify-content-center mt-3">
                     <Button
                        isLoading={isLoading}
                        type="button"
                        title="Save"
                        className="header-button"
                        onClick={handleSubmit}
                     />
                  </div>
               </Col>
            </Row>
         </div>
      </Modal>
   )
}

export default ManageImportGlobalEquipmentModal
